module.exports = "<!-- FORMULARIO PRODUCTOS -->\n<app-productosdetalle></app-productosdetalle>\n<!-- /FORMULARIO PRODUCTOS -->"